import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Robô ")
const _hoisted_5 = {
  class: "breadcrumb-item",
  "aria-current": "page"
}
const _hoisted_6 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_9 = {
  class: "tab-content border p-4",
  id: "nav-tabContent"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-dash",
  role: "tabpanel",
  "aria-labelledby": "nav-dash-tab"
}, " Gráficos sobre os emails enviados aqui ", -1)
const _hoisted_11 = {
  class: "tab-pane fade show active",
  id: "nav-funil",
  role: "tabpanel",
  "aria-labelledby": "nav-funil-tab"
}
const _hoisted_12 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_13 = {
  href: "javascript:void(0);",
  "data-bs-toggle": "modal",
  "data-bs-target": "#novogrupo"
}
const _hoisted_14 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = { class: "float-start" }
const _hoisted_18 = { class: "float-end btn-group" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "card mb-0 h-100" }
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "dropdown float-end" }
const _hoisted_29 = {
  href: "#",
  class: "dropdown-toggle arrow-none card-drop",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_30 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Novo")
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Testar")
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Detele")
const _hoisted_40 = { class: "header-title" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  class: "text-muted fw-normal mt-0 text-truncate",
  title: "Campaign Sent"
}
const _hoisted_43 = { class: "d-flex align-items-center mt-4" }
const _hoisted_44 = { class: "flex-shrink-0" }
const _hoisted_45 = { class: "font-13 text-muted my-0" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 ms-2" }, null, -1)
const _hoisted_48 = { class: "text-end" }
const _hoisted_49 = { class: "row g-1" }
const _hoisted_50 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none",
  title: "Total emails enviados"
}
const _hoisted_51 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none",
  title: "Total emails que tiveram cliques"
}
const _hoisted_52 = {
  href: "javascript:void(0);",
  class: "d-inline-block text-dark text-decoration-none",
  title: "Total emails abertos"
}
const _hoisted_53 = { class: "col-sm-1 col-xl-1 mb-2" }
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "border-dashed h-100 w-100 rounded d-flex align-items-center justify-content-center" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "font-16 mt-1 mb-0 d-block" }
const _hoisted_58 = { class: "col-sm-1 col-xl-1 mb-2" }
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = { class: "border-dashed h-100 w-100 rounded d-flex align-items-center justify-content-center" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "font-16 mt-1 mb-0 d-block" }
const _hoisted_63 = { class: "card-footer text-muted" }
const _hoisted_64 = {
  class: "tab-pane fade",
  id: "nav-form",
  role: "tabpanel",
  "aria-labelledby": "nav-form-tab"
}
const _hoisted_65 = {
  class: "tab-pane fade",
  id: "nav-lead",
  role: "tabpanel",
  "aria-labelledby": "nav-lead-tab"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-lp",
  role: "tabpanel",
  "aria-labelledby": "nav-lp-tab"
}, " Destinado a modelos de pagina para captura ", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-popup",
  role: "tabpanel",
  "aria-labelledby": "nav-popup-tab"
}, " Destinado a modelos de popup ", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "nav-config",
  role: "tabpanel",
  "aria-labelledby": "nav-config-tab"
}, " Destinado a configurações do robo, como quantidade de emails a serem enviados para um determinado período de tempo, edição do nome da lista e etc. ", -1)
const _hoisted_69 = {
  key: 0,
  class: "d-flex justify-content-center mt-4 mb-4"
}
const _hoisted_70 = {
  class: "modal fade",
  id: "novogrupo",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_71 = {
  class: "modal fade",
  id: "editgrupo",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_72 = {
  class: "modal fade",
  id: "novoemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_73 = {
  class: "modal fade",
  id: "editemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_74 = {
  class: "modal fade",
  id: "veragendaemail",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_75 = {
  class: "modal fade",
  id: "vergrupoleads",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GrupoForms = _resolveComponent("GrupoForms")!
  const _component_GrupoLeads = _resolveComponent("GrupoLeads")!
  const _component_NovoGrupo = _resolveComponent("NovoGrupo")!
  const _component_EditGrupo = _resolveComponent("EditGrupo")!
  const _component_NovoEmail = _resolveComponent("NovoEmail")!
  const _component_EditEmail = _resolveComponent("EditEmail")!
  const _component_VerAgendaEmail = _resolveComponent("VerAgendaEmail")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: `/listas/${$setup.route.params.t}/4/${$setup.route.params.perfil}`,
            class: "btn btn-sm btn-outline-secondary",
            title: "Robo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "robot" }),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_5, _toDisplayString($setup.dados.robo), 1),
        _createElementVNode("li", _hoisted_6, _toDisplayString($setup.menu), 1)
      ])
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-form-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-dash",
          type: "button",
          role: "tab",
          "aria-controls": "nav-dash",
          "aria-selected": "false",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changbreadmenu('Dasboard')))
        }, "Dasboard"),
        _createElementVNode("button", {
          class: "nav-link active",
          id: "nav-funil-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-funil",
          type: "button",
          role: "tab",
          "aria-controls": "nav-funil",
          "aria-selected": "true",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changbreadmenu('Sequencia Mail')))
        }, "Sequencia Mail"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-form-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-form",
          type: "button",
          role: "tab",
          "aria-controls": "nav-form",
          "aria-selected": "false",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changbreadmenu('Formulario')))
        }, "Formulario"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-lead-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-lead",
          type: "button",
          role: "tab",
          "aria-controls": "nav-lead",
          "aria-selected": "false",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changbreadmenu('Leads')))
        }, "Leads"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-lp-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-lp",
          type: "button",
          role: "tab",
          "aria-controls": "nav-lp",
          "aria-selected": "false",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changbreadmenu('Land Page')))
        }, "Land Page"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-popup-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-popup",
          type: "button",
          role: "tab",
          "aria-controls": "nav-popup",
          "aria-selected": "false",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changbreadmenu('Popups')))
        }, "Popups"),
        _createElementVNode("button", {
          class: "nav-link",
          id: "nav-config-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-config",
          type: "button",
          role: "tab",
          "aria-controls": "nav-config",
          "aria-selected": "false",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changbreadmenu('Configurações')))
        }, "Configurações")
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", _hoisted_13, [
            _createVNode(_component_font_awesome_icon, { icon: "file" })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("input", {
            class: "form-control",
            placeholder: "Procurar Nome ou Descrição",
            onKeyup: _cache[7] || (_cache[7] = ($event: any) => ($setup.search($event.target.value)))
          }, null, 32)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (grupo) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pt-3 pb-2 mb-3",
            key: grupo.id
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(grupo.name), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#vergrupoleads",
                    onClick: ($event: any) => ($setup.showleads(grupo.id)),
                    title: "ver leads do grupo"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "users" })
                  ], 8, _hoisted_19),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#editgrupo",
                    title: "Alterar Grupo",
                    onClick: ($event: any) => ($setup.Alterar(grupo.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                  ], 8, _hoisted_20),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Ativar grupo",
                    onClick: ($event: any) => ($setup.ativar(grupo.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "thumbs-up" })
                  ], 8, _hoisted_21),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Inativar grupo",
                    onClick: ($event: any) => ($setup.inativar(grupo.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "thumbs-down" })
                  ], 8, _hoisted_22),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-outline-secondary",
                    title: "Excluir grupo",
                    onClick: ($event: any) => ($setup.del(grupo.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                  ], 8, _hoisted_23)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.emails_order, (email) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-sm-3 col-xl-3 mb-3",
                      key: email.id
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("a", _hoisted_29, [
                              _createVNode(_component_font_awesome_icon, { icon: "envelope" })
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#novoemail",
                                id: "btnnovoemail",
                                onClick: ($event: any) => ($setup.emailnovo(grupo.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" }),
                                _hoisted_32
                              ], 8, _hoisted_31),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                onClick: ($event: any) => ($setup.emailteste(email.id,email.title))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                                _hoisted_34
                              ], 8, _hoisted_33),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#editemail",
                                id: "btneditemail",
                                onClick: ($event: any) => ($setup.emailedit(grupo.id,email.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" }),
                                _hoisted_36
                              ], 8, _hoisted_35),
                              _hoisted_37,
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "dropdown-item",
                                onClick: ($event: any) => ($setup.delEmail(email.id))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "trash-alt" }),
                                _hoisted_39
                              ], 8, _hoisted_38)
                            ])
                          ]),
                          _createElementVNode("h5", _hoisted_40, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "text-decoration-none",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#editemail",
                              id: "btneditemail",
                              onClick: ($event: any) => ($setup.emailedit(grupo.id,email.id))
                            }, _toDisplayString(email.title), 9, _hoisted_41)
                          ]),
                          _createElementVNode("h6", _hoisted_42, _toDisplayString(email.subject), 1),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("h6", _hoisted_45, [
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "text-decoration-none",
                                  title: "Click para Habilitar/Desabilitar Email",
                                  onClick: ($event: any) => ($setup.ativarInativarEmail(email.enable,email.id))
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(email.enable===1 ? 'badge bg-primary ' : 'badge bg-danger ')
                                  }, _toDisplayString(email.enable===1 ? ' Ativo ' : 'Inativo'), 3)
                                ], 8, _hoisted_46)
                              ])
                            ]),
                            _hoisted_47,
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("a", _hoisted_50, [
                                  _createVNode(_component_font_awesome_icon, { icon: "at" }),
                                  _createTextVNode("   " + _toDisplayString(email.totalemailsents.length), 1)
                                ]),
                                _createElementVNode("a", _hoisted_51, [
                                  _createVNode(_component_font_awesome_icon, { icon: "mouse" }),
                                  _createTextVNode("   " + _toDisplayString(email.emailclicks.length), 1)
                                ]),
                                _createElementVNode("a", _hoisted_52, [
                                  _createVNode(_component_font_awesome_icon, { icon: "book-reader" }),
                                  _createTextVNode("   " + _toDisplayString(email.emailreads.length), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "text-center text-muted p-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#novoemail",
                          id: "cardnovoemail",
                          onClick: ($event: any) => ($setup.emailnovo(grupo.id)),
                          title: "Novo Email"
                        }, [
                          _createElementVNode("h1", _hoisted_57, [
                            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                          ])
                        ], 8, _hoisted_56)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          class: "text-center text-muted p-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#veragendaemail",
                          id: "btnveragendaemail",
                          onClick: ($event: any) => ($setup.veragendaemail(grupo.id)),
                          title: "ver agenda dos emails"
                        }, [
                          _createElementVNode("h1", _hoisted_62, [
                            _createVNode(_component_font_awesome_icon, { icon: "clock" })
                          ])
                        ], 8, _hoisted_61)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("span", {
                  class: _normalizeClass(grupo.status===1 ? 'badge bg-primary ' : 'badge bg-danger ')
                }, _toDisplayString(grupo.status===1 ? ' Ativo ' : 'Inativo'), 3)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_64, [
        _createVNode(_component_GrupoForms, {
          onUpdateGroupFoms: $setup.loadForms,
          grupoforms: $setup.ListaGrupoForms
        }, null, 8, ["onUpdateGroupFoms", "grupoforms"])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_component_GrupoLeads, { grupo: $setup.grouplead }, null, 8, ["grupo"])
      ]),
      _hoisted_66,
      _hoisted_67,
      _hoisted_68
    ]),
    ($setup.page < $setup.lastPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_70, [
      _createVNode(_component_NovoGrupo, {
        onSetClick: $setup.close,
        listaid: `${$setup.route.params.listid}`,
        userid: `${$setup.dados.user_id}`
      }, null, 8, ["onSetClick", "listaid", "userid"])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _createVNode(_component_EditGrupo, {
        onSetClick: $setup.close,
        grupoid: `${$setup.choosegrupo}`
      }, null, 8, ["onSetClick", "grupoid"])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createVNode(_component_NovoEmail, {
        onSetClick: $setup.close,
        grupoid: `${$setup.choosegrupo}`,
        position: `${$setup.newposition}`
      }, null, 8, ["onSetClick", "grupoid", "position"])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createVNode(_component_EditEmail, {
        onSetClick: $setup.close,
        email: $setup.choosemail,
        groupmails: $setup.groupmails,
        urls: $setup.urls
      }, null, 8, ["onSetClick", "email", "groupmails", "urls"])
    ]),
    _createElementVNode("div", _hoisted_74, [
      _createVNode(_component_VerAgendaEmail, {
        onSetClick: $setup.close,
        grupoid: `${$setup.choosegrupo}`,
        emails: $setup.emailsag
      }, null, 8, ["onSetClick", "grupoid", "emails"])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createVNode(_component_GrupoLeads, {
        onSetClick: $setup.close,
        grupolead: `${$setup.grouplead}`
      }, null, 8, ["onSetClick", "grupolead"])
    ])
  ]))
}